module.exports = __webpack_public_path__ + "static/me-photo-hero-4f045212d0a07b34c5da9844f3f67e1a.png";